import { FundingType, IFunding } from '@bytel/leviator';
import {
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TitleMarkup,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

type FundingLegalsProps =
    | {
          funding: IFunding;
          type?: never;
      }
    | {
          type: FundingType.YOUNITED;
          funding?: never;
      };

export function FundingLegals({ type, funding }: Readonly<FundingLegalsProps>) {
    if (funding && (funding.type === FundingType.YOUNITED || funding.type === FundingType.SWAPPY)) {
        type = FundingType.YOUNITED;
    }

    return (
        <AccordionItem id='product-detail-funding-legals' data-cy='funding-legals' open>
            <AccordionHeader>
                <Title markup={TitleMarkup.H2} level={TitleLevels.SIX}>
                    Mentions légales du financement
                </Title>
            </AccordionHeader>
            <AccordionBody>
                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.ONE}>
                    Attention&nbsp;! Un crédit coûte de l&apos;argent et doit être remboursé.
                </Text>
                {funding && (
                    <Text level={TextLevels.TWO}>
                        <b>{funding.installments} mensualités de </b>
                        <InlinePrice amount={funding.monthlyAmount} period='mois' level={TextLevels.TWO} />.{' '}
                        <b>
                            Montant total dû <InlinePrice amount={funding.totalFinancingCost} level={TextLevels.TWO} />
                        </b>{' '}
                        (hors assurance facultative). <b>TAEG fixe&nbsp;: {funding.APR?.toLocaleString()}%</b>. Taux
                        débiteur fixe de {funding.fixedInterestRate?.toLocaleString()}%.
                    </Text>
                )}
                {type === FundingType.YOUNITED && <YounitedLegals />}
            </AccordionBody>
        </AccordionItem>
    );
}

function YounitedLegals() {
    return (
        <>
            <Text level={TextLevels.TWO}>
                Bouygues Telecom, 13-15 avenue du maréchal juin 92360 Meudon, - RCS de Nanterre 397&nbsp;480&nbsp;930,
                n°ORIAS&nbsp;: 11061269 est mandataire non-exclusif en opération de banque de Younited et apporte son
                concours à la réalisation d&apos;opérations de crédit sans agir en qualité de prêteur.
            </Text>
            <Text level={TextLevels.TWO}>
                Le financement est accordé sous réserve d&apos;acceptation par Younited, agréé en tant
                qu&apos;établissement de crédit - Prestataire de Service d&apos;Investissement par l&apos;Autorité de
                Contrôle Prudentiel et de Résolution (ACPR, n° d&apos;agrément&nbsp;: 16488). Vous disposez d&apos;un
                droit de rétractation de 14 jours calendaires révolus à compter de la signature de l&apos;offre de
                contrat de crédit.
            </Text>
            <Text level={TextLevels.TWO}>
                Younited SA à Directoire et Conseil de Surveillance, siège social&nbsp;: 21 rue de Châteaudun, 75009
                Paris - RCS de Paris 517&nbsp;586&nbsp;376 - n°ORIAS 11061269.
            </Text>
        </>
    );
}
